import { PerkFormValues } from "components/perksCrm/perksCrm.types";

const appendPerkFormValues = (
  formData: FormData,
  values: PerkFormValues,
  shouldInclude: (value: unknown) => boolean
) => {
  Object.entries(values).forEach(([key, value]) => {
    if (key === "icon" || key === "intro_emails") return;
    if (shouldInclude(value)) formData.append(key, value as string);
  });

  values.intro_emails.forEach((email) => {
    if (email) formData.append("intro_emails", email);
  });

  if (values.icon) formData.append("icon", values.icon);
};

export const buildCreatePerkFormData = (values: PerkFormValues): FormData => {
  const formData = new FormData();
  appendPerkFormValues(formData, values, Boolean);
  return formData;
};

export const buildUpdatePerkFormData = (values: PerkFormValues): FormData => {
  const formData = new FormData();
  appendPerkFormValues(
    formData,
    values,
    (value) => value !== undefined && value !== null
  );
  return formData;
};
